module.exports = __webpack_public_path__ + "static/media/settings.6c72351d.svg";